// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permission-modal {
  padding: 1rem;
}
.permission-modal .permission-modal-header {
  align-items: center;
  place-content: space-between;
  margin-bottom: 1rem;
}
.permission-modal .buttons {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
}
.permission-modal .buttons button {
  margin: 0 5px;
}
@media (max-width: 767px) {
  .permission-modal .buttons {
    flex-direction: column;
    padding: 0 1rem;
  }
  .permission-modal .buttons button {
    margin: 10px 0;
  }
}
.permission-modal h1 {
  font-size: 1rem;
}
.permission-modal .dropdown-label {
  cursor: pointer;
}
.permission-modal .dropdown-content {
  margin-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/permission-modal/permission-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,mBAAA;EACA,4BAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAGI;EATF;IAUI,sBAAA;IACA,eAAA;EAAJ;EAEI;IACE,cAAA;EAAN;AACF;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EACE,iBAAA;AAJJ","sourcesContent":[".permission-modal {\n  padding: 1rem;\n\n  .permission-modal-header {\n    align-items: center;\n    place-content: space-between;\n    margin-bottom: 1rem;\n  }\n\n  .buttons {\n    display: flex;\n    justify-content: center;\n    margin-top: 2.5rem;\n\n    button {\n      margin: 0 5px;\n    }\n\n    @media (max-width: 767px) {\n      flex-direction: column;\n      padding: 0 1rem;\n\n      button {\n        margin: 10px 0;\n      }\n    }\n  }\n\n  h1 {\n    font-size: 1rem;\n  }\n\n  .dropdown-label {\n    cursor: pointer;\n  }\n\n  .dropdown-content {\n    margin-left: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
